<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Officetrax Work Order Completions to Push"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Push work order completions to Officetrax."
      @on-submit="createOfficetraxWorkOrderCompletionsPushImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Officetrax Work Orders Completions to Push Template.xlsx"
              :file-provider="$importsAPI.getOfficetraxWorkOrdersCompletionsPushTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'OfficetraxWorkOrdersCompletionsPushImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'officetrax-work-orders-completions-push-imports-add-modal',
    };
  },
  methods: {
    createOfficetraxWorkOrderCompletionsPushImport(data, handleCreate) {
      handleCreate(this.$importsAPI.officetraxWorkOrdersCompletionsPushCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
